import { Typography } from '@libs/components';
import styled from 'styled-components';

export const IconWrapper = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 0.8rem;
`;

export const Img = styled.img`
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 0.8rem;
`;

export const TransactionContainer = styled.div`
  flex: 1;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  padding: 3.6rem 2.2rem 2rem 2.2rem;
  align-items: center;

  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem 3.6rem 3.6rem;
  
  `}
`;

export const Card = styled.div`
  border-radius: 1rem;
  min-height: 10.8rem;
  width: fit-content;
  justify-self: center;
  padding: 1.6rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.lg};
`;

export const CardWrapper = styled.div`
  align-items: center;
  justify-content: center;
`;

export const BankInfoWrapper = styled.div`
  margin-bottom: 1.2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const SaveTextWrapper = styled.div`
  margin-top: 2rem;
  margin-bottom: 2.4rem;
  text-align: center;
`;

export const CenterText = styled(Typography)`
  text-align: center;
`;

export const ModalContent = styled.div`
  padding: 1.6rem;

  max-width: 50rem;
  width: 100%;
  justify-self: center;

  ${({ theme }) => theme.media.laptop`
    width:50rem;
    padding: 1.6rem 3.6rem;
  `}
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.6rem;
`;

export const GradientWrapper = styled.div`
  border-top-left-radius: ${({ theme }) => theme.borderRadius.x5};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.x5};
  margin-top: -2.1rem;

  background: linear-gradient(180deg, #ebf1fe 0%, #fff 100%);
  flex: 1;
`;

export const BankCard = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  height: 10.8rem;
  width: 18.8rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.surface.default};
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.shadows.lg};
  justify-self: center;
`;
export const BankCardIconAndDate = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const BankCardIbanWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const Image = styled.img`
  height: 1.5rem;
`;

export const CryptoTransactionCenterText = styled(Typography)`
  text-align: center;
  word-break: break-all;
`;

export const CryptoTransactionCenterTextWrapper = styled.div`
  max-width: 26rem;
  justify-self: center;
`;

export const BankImage = styled.img`
  max-width: 3.2rem;
`;
